import { Component, computed, ElementRef, HostListener, ViewChild } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { AuthService, Profile } from '../../services/Auth/auth.service';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { gsap, Expo, Quart } from 'gsap';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { CommonModule } from '@angular/common';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { getMultiFactorResolver, MultiFactorResolver, PhoneInfoOptions, RecaptchaVerifier, sendPasswordResetEmail, signInWithPhoneNumber, UserCredential } from '@angular/fire/auth';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { HttpClientModule } from '@angular/common/http';
import { PhoneMaskDirective } from '../../directives/phone-mask.directive';
import { PhoneNumberPipe } from '../../pipes/phone-number.pipe';
import { SafeHtmlPipe } from '../../pipes/safe-html.pipe';
import { PasswordStrengthService } from '../../services/PasswordStrength/password-strength.service';

@Component({
    selector: 'app-login-page',
    standalone: true,
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatIconModule,
        MatButtonModule,
        MatCardModule, // Include MatCardModule
        MatSnackBarModule,
        MatCheckboxModule,
        HttpClientModule,
        PhoneNumberPipe,
        SafeHtmlPipe,
        PhoneMaskDirective
    ],
    templateUrl: './login-page.component.html',
    styleUrls: ['./login-page.component.scss']
})
export class LoginPageComponent {
    email: string = '';
    password: string = '';
    code: string = '';
    rePassword: string = '';
    firstName: string = '';
    lastName: string = '';
    // no: number = 1;
    phone: string = '';
    enableMultiFactor: boolean = false

    verificationCode: string = '';
    verificationId: string = '';
    confirmationResult: any;

    error: string = '';

    new_id: string | null = '';
    new_password: string | null = ''
    new_email: string | null = ''

    public verificationEmailSent: boolean = false
    public activeIndex: number = 0
    private timeoutId: any

    mfaRequired: boolean = false;
    mfaResolver!: MultiFactorResolver;
    isPasswordVisible: boolean = false
    isPasswordVisible2: boolean = false

    @ViewChild('bgVideo', { static: false }) public bgVideo: ElementRef | undefined;

    public active: string = 'splash';
    public mfaPhoneNumber: string = ''
    public codeError = ''
    public isNextButtonDisabled: boolean = true

    private currentPassword: string = ''

    public data = [

        {
            img: 'assets/login/Lionsgate-Repertory-Entry-Page-Hunger-Games.jpg ',
            imgMob: 'assets/login/Lionsgate-Repertory-Entry-Page-Hunger-Games-mobile.jpg',
            title: 'Hunger Games Mockingjay Pt1',
        }, {
            img: 'assets/login/Lionsgate-Repertory-Entry-Page-Dirty-Dancing.jpg',
            imgMob: 'assets/login/Lionsgate-Repertory-Entry-Page-Dirty-Dancing-mobile-v2.jpg',
            title: 'Dirty Dancing',
        },
        {
            img: 'assets/login/Lionsgate-Repertory-Entry-Page-John-Wick.jpg',
            imgMob: 'assets/login/Lionsgate-Repertory-Entry-Page-John-Wick-mobile.jpg',
            title: 'John Wick',
        },
        {
            img: 'assets/login/Lionsgate-Repertory-Entry-Page-Knives-Out-v2.jpg ',
            imgMob: 'assets/login/Lionsgate-Repertory-Entry-Page-Knives-Out-mobile.jpg',
            title: 'Knives Out',
        },
        {
            img: 'assets/login/Lionsgate-Repertory-Entry-Page-LA-LA-Land.jpg ',
            imgMob: 'assets/login/Lionsgate-Repertory-Entry-Page-LA-LA-Land-mobile.jpg',
            title: 'La La Land',
        },
        {
            img: 'assets/login/Lionsgate-Repertory-Entry-Page-Reservoir-Dogs.jpg',
            imgMob: 'assets/login/Lionsgate-Repertory-Entry-Page-Reservoir-Dogs-mobile.jpg',
            title: 'Reservoir Dogs',
        },
        {
            img: 'assets/login/Lionsgate-Repertory-Entry-Page-Titles-Grid.jpg ',
            imgMob: 'assets/login/Lionsgate-Repertory-Entry-Page-Titles-Grid-mobile.jpg',
            title: 'Browse the Lionsgate Library of Films',
        },
        {
            img: 'assets/login/Lionsgate-Repertory-Entry-Page-Twilight.jpg',
            imgMob: 'assets/login/Lionsgate-Repertory-Entry-Page-Twilight-mobile.jpg',
            title: 'Twilight',
        },

    ]

    @ViewChild('recaptchaContainer', { static: false }) recaptchaContainer!: ElementRef<HTMLDivElement>;

    public isMobile: boolean = false

    passwordStrength = this.passwordStrengthService.strength;
    strengthLevel = this.passwordStrengthService.getStrengthLevel(this.passwordStrength().score);

    constructor(
        public authService: AuthService,
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private snackBar: MatSnackBar,
        private breakpointObserver: BreakpointObserver,
        public passwordStrengthService: PasswordStrengthService
    ) {
        this.loop()

        breakpointObserver.observe([
            Breakpoints.HandsetLandscape,
            Breakpoints.HandsetPortrait
        ]).subscribe(result => {
            if (result.matches) {
                this.isMobile = true;
            }
            else {
                this.isMobile = false;
            }
        });

        this.strengthLevel = this.passwordStrengthService.getStrengthLevel(this.passwordStrength().score);
    }

    ngAfterViewInit() {
        setTimeout(() => {

            this.authService.recaptchaVerifier = new RecaptchaVerifier(
                this.authService.auth,
                this.recaptchaContainer.nativeElement,
                {
                    size: 'invisible',  // Makes it invisible
                    callback: (response: any) => {
                        console.log('reCAPTCHA solved:', response);
                        // Proceed with sign-in if needed
                    },
                    'expired-callback': () => {
                        console.log('reCAPTCHA expired');

                        this.authService.recaptchaVerifier?.render();  // Reset if expired
                    }
                }
            );
        }, 100);
        // setTimeout(() => {
        //     if (this && this.authService && this.authService.recaptchaVerifier) {
        //         this.authService.recaptchaVerifier.render()
        //             .then((widgetId) => {
        //                 this.authService.recaptchaWidgetId = widgetId;
        //             });
        //     }
        // }, 100);
    }

    ngOnInit() {
        this.authService.isEnabled$.subscribe(val => {
            // if (val == true) {
            //     this.router.navigateByUrl('/')
            // }
        })

        this.activatedRoute.paramMap.subscribe(params => {
            const section = params.get('id'); // 'id' is the parameter name from your route
            if (section) {
                this.active = section

                if (section == 'step1') {

                    // http://localhost:4200/login/step1?id=06oylh7QLYbZmiA9Bk4e844mDmk1&p=Bj%26__z%3Ehk7&e=ws@test.com

                    // "
                    // http://localhost:4200/login/step1?id=qzdAS9JaXINUyN9sBkleQ3UNfdq2&p=nCYBe%40T5!r6HJDy3fq%26R&e=reggie.ac@gmail.com
                    // "


                    let params = new URLSearchParams(window.location.search)
                    this.new_id = params.get('id')
                    this.new_email = params.get('e')
                    this.new_password = params.get('p')

                    if (this.new_email != null && this.new_password != null) {
                        this.authService.loginEmail(this.new_email, this.new_password).then(() => {
                            if (this.new_email) {
                                this.email = this.new_email
                            }
                            this.authService.profileLoaded$.subscribe((val: boolean) => {
                                if (val) {
                                    if (this.authService.profile?.firstName) {
                                        this.firstName = this.authService.profile?.firstName
                                    }
                                    if (this.authService.profile?.lastName) {
                                        this.lastName = this.authService.profile?.lastName
                                    }
                                    if (this.authService.profile?.phone) {
                                        this.phone = this.authService.profile?.phone
                                    }
                                }

                            })
                        })
                    }

                }
            }

            // const subSection = params.get('subSection'); 
            // if (subSection) {
            //     this.subSection = subSection
            // }
        });

        // setTimeout(() => {
        //     if (this.bgVideo && this.bgVideo.nativeElement) {
        //         this.bgVideo.nativeElement.muted = true;
        //         this.bgVideo?.nativeElement.play();
        //     }
        //     else {
        //         setTimeout(() => {
        //             if (this.bgVideo && this.bgVideo.nativeElement) {
        //                 this.bgVideo.nativeElement.muted = true;
        //                 this.bgVideo?.nativeElement.play();
        //             }
        //         }, 1000);
        //     }
        // }, 100);
    }

    ngOnDestroy() {
        clearTimeout(this.timeoutId)
    }

    loop() {
        // if(window.location.href.includes('localhost:4')) {
        // return
        // }
        clearTimeout(this.timeoutId)
        this.timeoutId = setTimeout(() => {
            this.next()
            this.loop()
        }, 5000);
    }

    next() {
        if (this.activeIndex < this.data.length - 1) {
            this.activeIndex++
        }
        else {
            this.activeIndex = 0
        }
    }

    async login() {
        try {
            this.snackBar.open('Sending...', '+', { duration: 1000 });
            await this.authService.loginEmail(this.email, this.password);
            setTimeout(() => {
                this.router.navigate([this.authService.pathAfterLogin]);
            }, 1000);
        } catch (error: any) {
            // this.error = error.message;
            if (error.code === 'auth/multi-factor-auth-required') {
                // Handle MFA
                this.codeError = ''
                this.authService.send2FA(error)
                this.active = 'login-2FA'
                this.mfaPhoneNumber = error.customData._serverResponse.mfaInfo[0].phoneInfo
            } else {
                this.snackBar.open('Email and password combination invalid.', '+', {
                    duration: 5000,
                    panelClass: ['red-error-snackbar'],
                });
            }
        }
    }

    loginSecondFactorCode() {
        this.snackBar.open('Sending...', '+', { duration: 1000 });

        this.authService.validate2FA(this.code).then(() => {
            setTimeout(() => {
                // this.router.navigate(['/']);
                this.router.navigate([this.authService.pathAfterLogin]);
            }, 1600);
        }).catch((error: any) => {
            if (error.code == 'auth/invalid-verification-code') {
                try {
                    this.authService.recaptchaVerifier?.clear()
                } catch (e) {

                }
                // this.codeError = 'SMS code invalid'
                this.snackBar.open('SMS code invalid.', '+', {
                    duration: 5000,
                    panelClass: ['red-error-snackbar'],
                });
            }
        })
    }

    onOpenLogin() {
        this.active = 'login';
        this.router.navigateByUrl('/login/login')
    }

    onCloseLogin() {
        this.active = 'splash';
        this.router.navigateByUrl('/login/splash')
    }

    onOpenRequest() {
        this.active = 'request';
        this.router.navigateByUrl('/login/request')
    }

    onCloseRequest() {
        this.active = 'splash';
        this.router.navigateByUrl('/login/splash')
    }

    stepOneCompleteRegistration() {
        if (this.password && this.password == this.rePassword) {

            // this.authService.changePassword(this.password, this.email).then(() => {
            if (this.authService.profile) {
                this.authService.profile.firstName = this.firstName
                this.authService.profile.lastName = this.lastName
                // this.authService.profile.phone = this.phone
                // this.authService.profile.mfa = this.enableMultiFactor
                this.authService.saveProfile()
            }

            this.active = 'step2'

            if (this.enableMultiFactor) {
                setTimeout(() => {
                    this.authService.enrollUser()
                    this.active = 'step1-mfa'
                    this.router.navigateByUrl('/login/step1-mfa')
                }, 1000);
                // this.authService.sendOtpForRequest(this.phone).then(() => {

                // })
            }
            // })

        }
        else {
            // popup password empty or no match
        }
    }

    retryCount: number = 4

    onStepPhone() {
        setTimeout(() => {
            if (this && this.authService && this.authService.recaptchaVerifier) {
                this.authService.recaptchaVerifier.render()
                    .then((widgetId) => {
                        this.authService.recaptchaWidgetId = widgetId;

                        this.authService.enrollUser().then(() => {
                            // sms sent
                            console.log('SMS code sent')
                        }).catch((err: any) => {
                            console.log(err)
                            try {

                                this.authService.recaptchaVerifier?.clear()
                            } catch (e) { }

                            let email = ''
                            if (this.new_email) {
                                email = this.new_email
                            }
                            let password = ''
                            if (this.new_password) {
                                password = this.new_password
                            }

                            console.log('logging out')
                            this.authService.logout().then(() => {
                                console.log('logging in')
                                this.authService.loginEmail(email, password, true).then(() => {
                                    // after login restart the process
                                    // try 3 times
                                    if (this.retryCount > 0) {
                                        this.retryCount--
                                        this.onStepPhone()
                                    }
                                })
                            })
                        })

                    }).catch((e: any) => {
                        // recaptcha error 
                        console.log('Recaptcha error restarting onStepPhone')
                        // try {

                        // this.authService.recaptchaVerifier?.clear()
                        // } catch() {
                        //     console.log('Clear failed')
                        // }
                        if (this.retryCount > 0) {
                            this.retryCount--
                            setTimeout(() => {
                                this.onStepPhone()
                            }, 500);
                        }
                    })
            }
        }, 10);

        if (this.authService.profile) {
            this.authService.profile.phone = this.phone
            this.authService.profile.mfa = true
            this.authService.saveProfile()
        }

        this.active = 'step1-mfa'
        // this.router.navigateByUrl('/login/step1-mfa')
    }

    onFinish() {
        if (this.authService.profile) {
            this.authService.profile.phone = this.phone
            this.authService.saveProfile()
        }
        this.authService.changePassword(this.password, this.email).then(() => {

        }).catch((e) => {
            console.log('Finish errro changing password, retrying after login ')
            // on error log in again
            let email = ''
            if (this.new_email) {
                email = this.new_email
            }
            let password = ''
            if (this.new_password) {
                password = this.new_password
            }

            this.authService.loginEmail(email, password, true).then(() => {
                // after login restart the process
                // try 3 times
                if (this.retryCount > 0) {
                    this.retryCount--
                    this.onFinish()
                }
            })
        })
        this.isPasswordVisible = false
        this.active = 'finish'
    }

    onStepOneMFA() {
        // this.authService.confirmationResult.confirm(this.verificationCode).then((userCredential : UserCredential) => {
        if (this.verificationCode == '') return


        this.authService.changePassword(this.password, this.email).then(() => {
            console.log('Password set')

            let email = ''
            if (this.new_email) {
                email = this.new_email
            }
            console.log('logging out 3')
            this.authService.logout().then(() => {
                console.log('logging in 3')
                this.authService.loginEmail(email, this.password, true).then(() => {

                    console.log('Enrolling user')
                    this.authService.enrollUserVerify(this.verificationCode).then(() => {
                        // this.router.navigateByUrl('/')
                        this.active = 'finish'
                        this.isPasswordVisible = false
                        this.router.navigateByUrl('/login/finish')
                    }).catch((e: any) => {
                        if (e.message.indexOf('The SMS verification code used to create the phone auth') != -1) {
                            this.snackBar.open("The code is invalid, please enter the correct code from the SMS.", '+', {
                                duration: 5000,
                                panelClass: ['red-error-snackbar'],
                            });
                        }
                        else {
                            this.snackBar.open(e, '+', {
                                duration: 5000,
                                panelClass: ['red-error-snackbar'],
                            });
                        }


                    })

                    // after login restart the process
                    // try 3 times
                    // if (this.retryCount > 0) {
                    //     this.retryCount--
                    //     this.onFinish()
                    // }
                })
            })


        }).catch((e) => {
            console.log('onStepOneMFA errro changing password, retrying after login ')
            // on error log in again
            let email = ''
            if (this.new_email) {
                email = this.new_email
            }
            let password = ''
            if (this.new_password) {
                password = this.new_password
            }
            console.log('logging out 2')
            this.authService.logout().then(() => {
                console.log('logging in 2')
                this.authService.loginEmail(email, password, true).then(() => {
                    // after login restart the process
                    // try 3 times
                    if (this.retryCount > 0) {
                        this.retryCount--
                        this.onStepOneMFA()
                    }
                })
            })
        })










        // }) 
    }

    onRequestSubmit() {
        console.log(this)

        this.password = this.authService.generateStrongPassword(10)

        var profile: Profile = new Profile({
            firstName: this.firstName,
            lastName: this.lastName,
            phone: this.phone,
            email: this.email,
        })

        try {
            this.authService.register(profile, this.email, this.password).subscribe(() => {
                console.log('thank you')
                this.active = 'thankyou'
            })

        } catch (e: any) {
            if (e && e.message && e.message.indexOf('The email address is already in use by another account') != -1) {
                this.snackBar.open("The Email address is already used.", '+', {
                    duration: 5000,
                    panelClass: ['red-error-snackbar'],
                });
            }
        }

    }

    @HostListener('window:blur')
    onBlur() {
        clearTimeout(this.timeoutId)


        // this.bgVideo?.nativeElement.pause();


    }

    @HostListener('window:focus')
    onFocus() {
        this.loop()

        // this.bgVideo?.nativeElement.play();


    }

    update(completed: boolean) {
        this.enableMultiFactor = completed
    }

    onReSendVerificationEmail() {
        this.verificationEmailSent = true
        // this.authService.sendVerificationEmail().then(() => {
        //     console.log('email sent')
        //     this.snackBar.open('Email Sent. Please click the link and come back to this site.', '+', { duration: 3000 });
        // })
    }

    reSendCode() {
        try {
            this.authService.recaptchaVerifier?.clear()
        } catch (e) {

        }
        this.login()
    }

    passwordVisibleToggle() {
        this.isPasswordVisible = !this.isPasswordVisible
    }

    passwordVisibleToggle2() {
        this.isPasswordVisible2 = !this.isPasswordVisible2
    }

    onPasswordChange(value: string) {
        this.passwordStrengthService.setPassword(value);
    }

    onRePasswordChange(value: string) {
        this.isNextButtonDisabled = true
        if (this.passwordStrength().isValid) {
            if (this.password == this.rePassword && this.password.length > 3) {
                this.isNextButtonDisabled = false
            }
        }
    }

    onForgotPassword() {
        this.active = 'passwordChange'
    }

    onForgotPasswordClose() {
        this.active = 'login'
    }

    async onForgotPasswordSubmit() {
        if (!this.email) {
            this.error = 'Please enter your email address.';
            this.snackBar.open(this.error, '+', {
                duration: 3000,
                panelClass: ['red-error-snackbar'],
            });
            return;
        }

        try {
            this.error = '';
            await sendPasswordResetEmail(this.authService.auth, this.email);

            this.snackBar.open('Password reset email sent! ', '+', { duration: 5000 });


            this.active = 'passwordChange-result'
        } catch (err: any) {
            console.error('Password reset error:', err);
            switch (err.code) {
                case 'auth/user-not-found':
                    this.error = 'No user found with this email address.';
                    break;
                case 'auth/invalid-email':
                    this.error = 'Invalid email address.';
                    break;
                case 'auth/too-many-requests':
                    this.error = 'Too many requests. Please try again later.';
                    break;
                default:
                    this.error = 'Failed to send reset email. Please try again.';
            }
            this.snackBar.open(this.error, '+', {
                duration: 5000,
                panelClass: ['red-error-snackbar'],
            });
        }
    }

    onResendCode() {
        this.retryCount = 4
        this.active = 'step2'
        // this.onStepPhone()        
    }
}
